import h from "./design-system.es126.js";
import u from "./design-system.es101.js";
import f from "./design-system.es99.js";
import { resolveComponent as a, openBlock as o, createElementBlock as i, createElementVNode as r, createVNode as _, withCtx as b, Fragment as T, renderList as v, createBlock as k, normalizeClass as C, withModifiers as H, createTextVNode as c, renderSlot as d, createCommentVNode as B } from "vue";
/* empty css                    */
import $ from "./design-system.es128.js";
const x = {
  name: "DsTabset",
  components: {
    TabHeader: u,
    TabHeaderItem: f
  },
  provide() {
    return { emitter: this.emitter };
  },
  data() {
    return {
      activeTab: null,
      tabs: [],
      hasOptions: !1
    };
  },
  watch: {
    tabs: {
      handler() {
        this.emitter.emit("TAB_HEADER_TABS_UPDATED");
      },
      deep: !0
    }
  },
  beforeCreate() {
    this.emitter = h();
  },
  beforeUnmount() {
    this.emitter.off("*");
  },
  mounted() {
    this.checkOptions();
  },
  methods: {
    register(e) {
      this.tabs.push(e);
    },
    select(e) {
      this.activeTab = e, this.emitter.emit("activateTab", e);
    },
    selectByIndex(e) {
      this.select(this.tabs[e]);
    },
    checkOptions() {
      this.$nextTick(() => {
        this.hasOptions = this.$slots.options !== void 0;
      });
    }
  }
}, E = { class: "tabset" }, I = { class: "tab-header" }, O = {
  key: 0,
  class: "tab-options"
}, w = { class: "tab-content" };
function y(e, s, A, D, n, l) {
  const m = a("TabHeaderItem"), p = a("TabHeader");
  return o(), i("div", E, [
    r("div", I, [
      _(p, null, {
        default: b(() => [
          (o(!0), i(T, null, v(n.tabs, (t) => (o(), k(m, {
            key: t.key,
            active: t.show,
            icon: t.icon,
            label: t.label,
            class: C(t.classList),
            "data-qa": t.dataQa,
            onClick: H((N) => l.select(t), ["prevent"])
          }, null, 8, ["active", "icon", "label", "class", "data-qa", "onClick"]))), 128))
        ]),
        _: 1
      }),
      s[0] || (s[0] = c()),
      n.hasOptions ? (o(), i("div", O, [
        d(e.$slots, "options", {}, void 0, !0)
      ])) : B("", !0)
    ]),
    s[1] || (s[1] = c()),
    r("div", w, [
      d(e.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const z = /* @__PURE__ */ $(x, [["render", y], ["__scopeId", "data-v-85e083ee"]]);
export {
  z as default
};
//# sourceMappingURL=design-system.es105.js.map
